import { render } from "./KADLModalImport.vue?vue&type=template&id=4bc4c411"
import script from "./KADLModalImport.vue?vue&type=script&lang=js"
export * from "./KADLModalImport.vue?vue&type=script&lang=js"

import "./KADLModalImport.vue?vue&type=style&index=0&id=4bc4c411&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__